import { call, options, params } from './helpers';

export const getModules = (payload) => call(`/beta/modules${params(payload)}`);
export const getModule = ({ id }) => call(`/beta/modules/${id}`);
export const getModuleFields = ({ id, ...payload }) =>
	call(`/beta/modules/${id}/fields${params(payload)}`);

export const getModuleFieldsBeta = ({ id, ...payload }) =>
	call(`/beta/modules/${id}/fields/beta${params(payload)}`);

export const getModuleCategories = ({ id, ...payload }) =>
	call(`/beta/modules/${id}/categories${params(payload)}`);

export const getModuleCategoriesByModuleKey = ({ ...payload }) =>
	call(`/beta/modules/categories${params(payload)}`);

export const addModuleFields = ({ id, ...payload }) =>
	call(`/beta/modules/${id}/fields`, options(payload, 'POST'));

export const updateModuleField = ({ id, ...payload }) =>
	call(`/beta/modules/${id}/fields`, options(payload, 'PUT'));

export const deleteModuleField = ({ id, ...payload }) =>
	call(`/beta/modules/${id}/fields`, options(payload, 'DELETE'));

export const updateModuleFieldActive = ({ id, ...payload }) =>
	call(`/beta/modules/${id}/fields/setActive`, options(payload, 'PUT'));

/*export const updateModule = ({ id, ...payload }) =>
	call(`/beta/modules/${id}`, options(payload, 'PUT'));
export const addModule = (payload) =>
	call(`/beta/modules`, options(payload, 'POST'));
export const deleteModule = ({ id }) =>
	call(`/beta/modules/${id}`, options(null, 'DELETE'));
*/
